import { Modifier } from "@dnd-kit/core";

// BUG: When two non-empty cells are adjacent, the span control currently can move into the occupied cell.
export const restrictSpanExtensionControlToEmptyCells: Modifier = ({
  active,
  containerNodeRect,
  draggingNodeRect,
  over,
  transform,
}) => {
  const activeTarget = active?.data.current?.target;
  const overTarget = over?.data.current?.target;
  const activeCellIndex = active?.data.current?.data?.cellIndex;
  const overCellIndex = over?.data.current?.data?.cellIndex;
  const activeData = active?.data.current?.data;
  const overData = over?.data.current?.data;
  const spanDirection = activeData?.direction;

  const isHoveringInnerCell = overTarget === "inner-cell";
  const isSpanControl = activeTarget === "span-control";

  const isHoveringOwnParent =
    isHoveringInnerCell && overCellIndex === activeCellIndex;

  if (!draggingNodeRect || !containerNodeRect || !isSpanControl) {
    return transform;
  }

  // don't let the control pass through the left side of the parent cell when blocked
  if (
    isHoveringOwnParent &&
    spanDirection === "right" &&
    overData?.cellSpanBoundaries?.right
  ) {
    // don't let it pass through the right side of the parent cell
    const rightBoundary = over?.rect?.right;
    const draggingNodePosition = draggingNodeRect.right + transform.x;
    const hasHitRightBoundary =
      rightBoundary && draggingNodePosition >= rightBoundary;

    if (hasHitRightBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.right - draggingNodeRect.right;
      value.x = stopPositionX;

      return value;
    }
  }

  // don't let the control pass through the left side of the parent cell when blocked
  if (
    isHoveringOwnParent &&
    spanDirection === "left" &&
    overData?.cellSpanBoundaries?.left
  ) {
    const leftBoundary = over?.rect?.left;
    const draggingNodePosition = draggingNodeRect.left + transform.x;
    const hasHitLeftBoundary =
      leftBoundary && draggingNodePosition <= leftBoundary;

    if (hasHitLeftBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.left - draggingNodeRect.left;
      value.x = stopPositionX;

      return value;
    }
  }

  // don't let the right span pass through the left boundary of the parent cell
  if (isHoveringOwnParent && spanDirection === "right") {
    const leftBoundary = over?.rect?.left;
    const draggingNodePosition = draggingNodeRect.left + transform.x;
    const hasHitLeftBoundary =
      leftBoundary && draggingNodePosition <= leftBoundary;

    if (hasHitLeftBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.left - draggingNodeRect.left;
      value.x = stopPositionX;

      return value;
    }
  }

  // don't let the left span pass through the right boundary of the parent cell
  if (isHoveringOwnParent && spanDirection === "left") {
    const rightBoundary = over?.rect?.right;
    const draggingNodePosition = draggingNodeRect.right + transform.x;
    const hasHitRightBoundary =
      rightBoundary && draggingNodePosition >= rightBoundary;

    if (hasHitRightBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.right - draggingNodeRect.right;
      value.x = stopPositionX;

      return value;
    }
  }

  // don't let the control pass through the right side a blocked empty cell
  const isHoveringCellBlockedRight = overData?.cellBoundaries?.right === true;
  if (isHoveringCellBlockedRight && spanDirection === "right") {
    const rightBoundary = over?.rect?.right;
    const draggingNodePosition = draggingNodeRect.right + transform.x;
    const hasHitRightBoundary =
      rightBoundary && draggingNodePosition >= rightBoundary;

    if (hasHitRightBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.right - draggingNodeRect.right;
      value.x = stopPositionX;

      return value;
    }
  }

  // don't let the control pass through the left side a blocked empty cell
  const isHoveringCellBlockedLeft = overData?.cellBoundaries?.left === true;
  if (isHoveringCellBlockedLeft && spanDirection === "left") {
    const leftBoundary = over?.rect?.left;
    const draggingNodePosition = draggingNodeRect.left + transform.x;
    const hasHitLeftBoundary =
      leftBoundary && draggingNodePosition <= leftBoundary;

    if (hasHitLeftBoundary) {
      const value = {
        ...transform,
      };

      const stopPositionX = over?.rect?.left - draggingNodeRect.left;
      value.x = stopPositionX;

      return value;
    }
  }

  return transform;
};
